import { locale as en } from './i18n/en';

export const locales = [en];
